import axios from 'axios'

const stores = {
  state: {
    usersList: [],
    userInfo: {}
  },
  mutations: {
    SET_USERS_DATA (state, data) {
      state.usersList = data
    },
    SET_USER_INFO (state, data) {
      state.userInfo = data
    },
    SET_USER_IMG (state, path) {
      state.userInfo.userImgPath = path
    },
    REMOVE_USERS_DATA (state) {
      state.userInfo = {}
      state.usersList = []
    }
  },
  actions: {
    fetchUsers ({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/users')
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchUserInfo ({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/users/currentUser')
          .then(response => {
            commit('SET_USER_INFO', response.data)
            resolve(response)
          })
          .catch(error => {
            dispatch('errorsHandler', {params: error})
            // reject(error)
          })
      })
    }
  },
  getters: {
    getUserInfo (state) {
      return state.userInfo
    }
  }
}

export default stores
